import { useEffect } from "react";

const PageSEO = ({ title, description, keywords }) => {
	useEffect(() => {
		document.title = title;

		const setMeta = (name, content) => {
			if (!content) return;
			let el = document.querySelector(`meta[name="${name}"]`);
			if (!el) {
				el = document.createElement("meta");
				el.setAttribute("name", name);
				document.head.appendChild(el);
			}
			el.setAttribute("content", content);
		};

		setMeta("description", description);
		setMeta("keywords", keywords);

		return () => {
			document.title = "Airport Taxi Transfers Varna";
		};
	}, [title, description, keywords]);

	return null;
};

export default PageSEO;
